<template>
  <div :class="`alert-${type}`" class="alert small my-1 py-2">
    <span class="message">{{ message }}</span>
    <ul>
      <li v-for="(value, key, index) in list" :key="index" v-show="value">
        {{ value }}
      </li>
    </ul>
    <button v-if="closeButton" @click="close()" class="btn-clean">
      <MaterialSvg name="close" :width="20" />
    </button>
  </div>
</template>

<script>
export default {
  name: 'Message',
  props: {
    message: {
      type: String,
      required: false,
    },
    list: {
      type: [Object, Array],
      required: false,
    },
    type: {
      type: String,
      default: 'info',
      required: false,
    },
    closeButton: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  methods: {
    // This function is not implemented yet.
    // No use case in the application so far.
    close() {},
  },
};
</script>

<style scoped lang="scss">
.alert {
  .message {
    margin-bottom: 0.2rem;
  }
  ul {
    margin-bottom: 0;
    padding-left: 1.25em;
  }
}
</style>
